import { ChangeDetectionStrategy, Component } from "@angular/core";

@Component({
  selector: "app-perfil",
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: "./perfil.component.html"
})
export class PerfilComponent {}
